/**
 * LISTADO COMPLETO DE ENDPOINTS DE LA API DE GESTIÓN DE CASOS https://apigestioncasosdev.azurewebsites.net/swagger/v1/swagger.json
 * @description Cada endpoint incluye su método HTTP y una breve descripción de su funcionalidad.
 */
const URL_API_GESTION_CASOS = {
    // Endpoints de Autenticación
    /**
     * Endpoint para Iniciar Sesión.
     * Método: POST
     * Descripción: Permite iniciar una sesión de usuario en el sistema.
     */
    INICIAR_SESION: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/IniciarSesion`,

    /**
     * Endpoint para Renovar Token.
     * Método: POST
     * Descripción: Renueva el token de acceso del usuario para mantener la sesión activa.
     */
    RENOVAR_TOKEN: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/RenovarToken`,

    /**
     * Endpoint para Generar OTP (One-Time Password).
     * Método: POST
     * Descripción: Genera y envía un código de un solo uso para autenticación o validación.
     */
    GENERAR_OTP: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/GenerarOTP`,

    /**
     * Endpoint para Validar OTP.
     * Método: POST
     * Descripción: Valida el código de un solo uso proporcionado por el usuario.
     */
    VALIDAR_OTP: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/ValidarOTP`,

    /**
     * Endpoint para Verificar si un Usuario Existe.
     * Método: POST
     * Descripción: Comprueba si un usuario ya se encuentra registrado en el sistema.
     */
    VERIFICAR_USUARIO_EXISTE: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/VerificarUsuarioExiste`,

    /**
     * Endpoint para Cambiar Contraseña.
     * Método: POST
     * Descripción: Permite a un usuario autenticado cambiar su contraseña.
     */
    CAMBIAR_CONTRASENA: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/CambiarContrasena`,

    /**
     * Endpoint para Validar Contraseña.
     * Método: POST
     * Descripción: Verifica la validez de una contraseña para un usuario.
     */
    VALIDAR_CONTRASENA: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/ValidarContrasena`,

    // Endpoints de Autenticación (Versión 2)
    /**
     * Endpoint de Verificación de Estado (Health Check).
     * Método: GET
     * Descripción: Punto público para sistemas de monitoreo para verificar la disponibilidad del servicio.
     */
    HEALTH_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/health`,

    /**
     * Endpoint para Registro de Usuario.
     * Método: POST
     * Descripción: Crea una nueva cuenta de usuario en el sistema.
     */
    REGISTRO_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/register`,

    /**
     * Endpoint de Inicio de Sesión.
     * Método: POST
     * Descripción: Valida credenciales y emite tokens de acceso y refresco.
     */
    LOGIN_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/login`,

    /**
     * Endpoint para Refrescar Token.
     * Método: POST
     * Descripción: Intercambia un token de refresco válido por un nuevo par de tokens.
     */
    REFRESCAR_TOKEN_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/refresh`,

    /**
     * Endpoint para Cerrar Sesión.
     * Método: POST
     * Descripción: Revoca el token de refresco y finaliza la sesión actual.
     */
    CERRAR_SESION_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/logout`,

    /**
     * Endpoint para Obtener Usuario Actual.
     * Método: GET
     * Descripción: Devuelve la información del perfil del usuario autenticado.
     */
    OBTENER_USUARIO_ACTUAL_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/me`,

    /**
     * Endpoint para Cambiar Contraseña.
     * Método: POST
     * Descripción: Permite al usuario autenticado cambiar su contraseña.
     */
    CAMBIAR_CONTRASENA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/change-password`,

    /**
     * Endpoint para Olvidar Contraseña.
     * Método: POST
     * Descripción: Inicia el flujo de recuperación de contraseña.
     */
    OLVIDO_CONTRASENA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/forgot-password`,

    /**
     * Endpoint para Resetear Contraseña.
     * Método: POST
     * Descripción: Completa el proceso de reseteo de contraseña.
     */
    RESETEAR_CONTRASENA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/reset-password`,

    /**
     * Endpoint para Listar Sesiones.
     * Método: GET
     * Descripción: Obtiene un listado de las sesiones activas del usuario actual.
     */
    LISTAR_SESIONES_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/sessions`,

    /**
     * Endpoint para Revocar una Sesión específica.
     * Método: DELETE
     * Descripción: Revoca una sesión específica por su ID.
     */
    REVOCAR_SESION_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/sessions/{sessionId}`,

    /**
     * Endpoint para Revocar todas las Sesiones.
     * Método: POST
     * Descripción: Cierra todas las sesiones del usuario actual.
     */
    REVOCAR_TODAS_SESIONES_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/sessions/revoke-all`,

    /**
     * Endpoint para Obtener Roles.
     * Método: GET
     * Descripción: Obtiene los roles de usuario disponibles. Requiere rol de administrador.
     */
    OBTENER_ROLES_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/roles`,

    /**
     * Endpoint para Habilitar 2FA (Two-Factor Authentication).
     * Método: POST
     * Descripción: Habilita la autenticación de dos factores para el usuario.
     */
    HABILITAR_2FA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/2fa/enable`,

    /**
     * Endpoint para Verificar 2FA.
     * Método: POST
     * Descripción: Verifica un código de autenticación de dos factores.
     */
    VERIFICAR_2FA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/2fa/verify`,

    /**
     * Endpoint para Deshabilitar 2FA.
     * Método: POST
     * Descripción: Deshabilita la autenticación de dos factores.
     */
    DESHABILITAR_2FA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/2fa/disable`,

    /**
     * Endpoint para Regenerar Códigos de Respaldo 2FA.
     * Método: POST
     * Descripción: Genera nuevos códigos de respaldo para la autenticación de dos factores.
     */
    REGENERAR_CODIGOS_2FA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/2fa/backup-codes`,

    /**
     * Endpoint para Generar Imagen QR 2FA.
     * Método: GET
     * Descripción: Genera una imagen de código QR para configurar la autenticación de dos factores.
     */
    GENERAR_QR_2FA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/2fa/qr-image`,

    /**
     * Endpoint de Debug para Código Actual 2FA.
     * Método: GET
     * Descripción: (Uso temporal para depuración) Obtiene el código TOTP actual.
     */
    DEBUG_CODIGO_ACTUAL_2FA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/2fa/debug-current-code`,

    /**
     * Endpoint de Debug para Verificación Detallada 2FA.
     * Método: POST
     * Descripción: (Uso temporal para depuración) Verifica un código 2FA y muestra detalles de la comparación.
     */
    DEBUG_VERIFICAR_DETALLADO_2FA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/2fa/debug-verify-detailed`,

    // Endpoints de Configuración
    /**
     * Endpoint para Obtener Microservicios.
     * Método: GET
     * Descripción: Devuelve la lista de microservicios disponibles.
     */
    OBTENER_MICROSERVICIOS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Configuracion/GetMicroservicios`,

    // Endpoints de Contactos
    /**
     * Endpoint para Registrar Perfil.
     * Método: POST
     * Descripción: Registra un nuevo perfil de contacto de usuario.
     */
    REGISTRAR_PERFIL: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Contactos/RegistrarPerfil`,

    /**
     * Endpoint para Validar Usuario.
     * Método: POST
     * Descripción: Valida la información de un usuario.
     */
    VALIDAR_USUARIO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Contactos/ValidarUsuario`,

    /**
     * Endpoint para Guardar Validación VU.
     * Método: POST
     * Descripción: Almacena los resultados de la validación de un usuario.
     */
    GUARDAR_VALIDACION_VU: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Contactos/GuardarValidacionVU`,

    // Endpoints de Entidad
    /**
     * Endpoint para Registrar Perfil de Entidad.
     * Método: POST
     * Descripción: Registra un nuevo perfil para una entidad.
     */
    REGISTRAR_PERFIL_ENTIDAD: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Entidad/RegistrarPerfilEntidad`,

    /**
     * Endpoint para Verificar si una Entidad Existe.
     * Método: POST
     * Descripción: Comprueba si una entidad ya se encuentra registrada en el sistema.
     */
    VERIFICAR_ENTIDAD_EXISTE: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Entidad/VarificarEntidadExiste`,

    // Endpoints de Portal Dashboard
    /**
     * Endpoint para Obtener Servicios del Portal.
     * Método: POST
     * Descripción: Devuelve los servicios y funcionalidades disponibles para el portal.
     */
    OBTENER_SERVICIOS_PORTAL: `${import.meta.env.VITE_API_GESTION_CASOS}/api/PortalDasboard/GetServiciosPortal`,
    
    /**
     * Endpoint para Establecer si es Primer Inicio Sesion del usuario
     * Método: PATCH
     * Descripción: 
     */
    ESTABLECER_ES_PRIMER_INICIO_SESION: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/EstablecerEsPrimerInicioSesion`,
    /**
     * Endpoint para Obtener información del usuario actual (v2).
     * Método: GET
     * Descripción: 
     */
    ME: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/me`,
    /** 
     * Endpoint para Actualizar Perfil de Ciudadano -> Abogado.
     * Método: POST
     * Descripción: Actualiza la información del perfil de un ciudadano -> abogado.
     */
    ACTUALIZAR_PERFIL_CIUDADANO_ABOGADO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/actualizar-perfil`,
    /**
     * Endpoint para Gestionar Documento Personal del Usuario.
     * Método: POST
     * Descripción: Permite agregar o actualizar un documento personal del usuario.
     */
    GESTIONAR_DOCUMENTO_PERSONAL_USUARIO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/gestion-documento-personal-usuario`,
    /**
     * Endpoint para Obtener Documento Personal del Usuario.
     * Método: GET
     * Descripción: Recupera la información de un documento personal específico del usuario.
     */
    OBTENER_DOCUMENTO_PERSONAL_USUARIO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/obtener-documento-personal-usuario`,
    /**
     * Endpoint para Obtener Documentos Personales del Usuario.
     * Método: GET
     * Descripción: Recupera la lista de documentos personales del usuario.
     */
    OBTENER_DOCUMENTOS_PERSONALES_USUARIO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/obtener-documentos-personales-usuario`,
    /**
     * Endpoint para Eliminar Documento Personal del Usuario.
     * Método: DELETE
     * Descripción: Elimina un documento personal específico del usuario.
     */
    ELIMINAR_DOCUMENTO_PERSONAL_USUARIO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/eliminar-documento-personal-usuario`
};

export default URL_API_GESTION_CASOS;